/**
 * I ruoli esterni (27/10/2026 gli agenti, 28/10 i professionisti): persone che
 * non sono di Masamune e vedono SOLO la loro pagina. Qui si dice quale: la usano
 * l'instradamento (App.tsx), il menu, la barra in alto e il guscio dell'app.
 * L'API li chiude per conto suo (apps/api/src/lib/recinto.ts): qui si evita di
 * mostrare pagine vuote, la ricerca e il resto del gestionale.
 * Cosa vede ogni ruolo, detto in una frase, sta in lib/ruoli.ts.
 */
import type { IconName } from '../components/ui/Icon';

export interface PaginaEsterna { to: string; label: string; icon: IconName }

const PAGINE: Record<string, PaginaEsterna> = {
  AGENTE: { to: '/agenti', label: 'Le tue provvigioni', icon: 'handshake' },
  PROFESSIONISTA: { to: '/area', label: 'Il tuo lavoro', icon: 'tasks' },
};

/** La pagina di un ruolo esterno, o undefined per chi lavora in Masamune. */
export function paginaEsterna(roleKey: string | null | undefined): PaginaEsterna | undefined {
  return roleKey ? PAGINE[roleKey] : undefined;
}
